import Axios from 'axios';

export default {
  getModules: () => Axios.get('module/getModules'),
  getModulesAllowed: () => Axios.get('module/getModulesAllowed'),
  getDefaultModule: () => Axios.get('module/getDefaultModule'),
  getDefaultPage: IdModule => Axios.post('module/GetDefaultPage', { IdModule }),
};
